import styled from '@emotion/styled'
import { css } from '@emotion/react'

export const MainContentStyles = ({ theme }) => {
  const PackageCard = theme?.components?.PackageCard

  return css`
    width: 100%;
    margin-top: auto;
    display: flex;
    flex-direction: column;
    text-align: ${PackageCard?.alignment};
    color: ${`${PackageCard?.color || 'black'} !important`};

    .leshen-phone-cta svg {
      margin: 0;
    }

    > {
      margin-bottom: 8px;
    }
  `
}
export const MainContent = styled.div(MainContentStyles)
